import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, withStyles, ButtonBase } from '@material-ui/core';

import { COLOR_MAP } from 'constants/appStyling/options';
import { ReaderSettingsValuesContext } from 'contexts';

const useStyles = makeStyles((theme) => {
  return {
    root: {},
  };
});

const StyledMarkerButton = withStyles((theme) => {
  return {
    root: {
      width: '24px',
      height: '24px',
      borderRadius: '4px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: (props) =>
        props.bordercolor ?? theme.palette.status.red.main,

      margin: '8px',
      backgroundColor: (props) =>
        props.backgroundcolor ?? theme.palette.status.red.light,
    },
  };
})(ButtonBase);

const NoteRailMarker = ({ colorInfo, className, onClick, ...props }) => {
  const highlightColors = useContext(ReaderSettingsValuesContext);
  const { background, border } = highlightColors[COLOR_MAP[colorInfo]] ?? {};
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <StyledMarkerButton
        key={`${colorInfo}-key`}
        aria-label={`${colorInfo} highlight`}
        {...(colorInfo !== 'collaboration'
          ? {
              backgroundcolor: background,
              bordercolor: border,
            }
          : {})}
        onClick={onClick}
        disableRipple
      />
    </div>
  );
};

NoteRailMarker.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
};

export default NoteRailMarker;
